import { BASE, request } from "./client";

export interface StartCallRequest { number: string; playbook_id: string; gateway?: string; params?: Record<string, string> }
export interface StartCallResponse { call_id: string; session_id: string; greeting: string }
export interface CallStatusResponse { call_id: string; session_id: string; number: string; playbook_id: string; status: string; started_at: number; hangup_cause: string; hangup_by: string }

export function startCall(req: StartCallRequest): Promise<StartCallResponse> {
  return request("/call", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(req),
  });
}

export function getCallStatus(callId: string): Promise<CallStatusResponse> {
  return request(`/call/${callId}`);
}

export function hangupCall(callId: string): Promise<{ call_id: string; status: string }> {
  return request(`/call/${callId}/hangup`, { method: "POST" });
}

export function callRecordingUrl(callId: string): string {
  return `${BASE}/call/${callId}/recording`;
}

export interface Gateway {
  id: string;
  name: string;
  dial_string: string;
  caller_ids: string[];
  caller_id_prefix: string;
  enabled: boolean;
  weight: number;
  daily_limit: number;
  created_at: number;
}

export interface CreateGatewayRequest {
  name: string;
  dial_string: string;
  caller_ids: string[];
  caller_id_prefix?: string;
  enabled?: boolean;
  weight?: number;
  daily_limit?: number;
}

export type UpdateGatewayRequest = Partial<CreateGatewayRequest>;

export function listGateways(): Promise<Gateway[]> {
  return request("/gateways");
}

export function createGateway(req: CreateGatewayRequest): Promise<{ id: string }> {
  return request("/gateways", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(req),
  });
}

export function updateGateway(id: string, req: UpdateGatewayRequest): Promise<{ ok: boolean }> {
  return request(`/gateways/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(req),
  });
}

export function deleteGateway(id: string): Promise<{ ok: boolean }> {
  return request(`/gateways/${id}`, { method: "DELETE" });
}
